// extracted by mini-css-extract-plugin
export default {"settings":"DaysSetting_settings__arCVt","days":"DaysSetting_days__asXxN","input":"DaysSetting_input__mP0Or"};